import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import GeneralSettingsForm from "@/admin/components/settings/GeneralSettingsForm";
import MailSettingsForm from "@/admin/components/settings/MailSettingsForm";
import SmsSettingsForm from "@/admin/components/settings/SmsSettingsForm";
import Container from "@/components/containers/Container";
import Tab from "@/components/containers/tabs/Tab";
import TabGroup from "@/components/containers/tabs/TabGroup";
import TabList from "@/components/containers/tabs/TabList";
import TabPanel from "@/components/containers/tabs/TabPanel";
import TabPanels from "@/components/containers/tabs/TabPanels";
import { type ChildRouteContext } from "@/root";
import { throwIfHasNoPermission } from "@/utils/permissions";

export const Route = createFileRoute("/admin/_panel/_settings/settings/")({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    throwIfHasNoPermission(context.user, "core.general-settings.view");

    return {} satisfies ChildRouteContext;
  },
});

function RouteComponent() {
  const { t } = useTranslation("core.shared");

  return (
    <Container title={t("Organization")}>
      <TabGroup>
        <TabList>
          <Tab>{t("Organization Details")}</Tab>
          <Tab>{t("SMS Panel")}</Tab>
          <Tab>{t("Email")}</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <GeneralSettingsForm />
          </TabPanel>
          <TabPanel>
            <SmsSettingsForm />
          </TabPanel>
          <TabPanel>
            <MailSettingsForm />
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </Container>
  );
}
